import { useState, useEffect } from 'react'

const useWindowSize = () => {
  const [value, setValue] = useState(() => ({
    width: null,
    height: null
  }))

  useEffect(() => {
    const sizeHandler = () => {
      setValue({
        width: window.innerWidth,
        height: window.innerHeight
      })
    }

    sizeHandler()
    window.addEventListener('resize', sizeHandler)

    return () => {
      window.removeEventListener('resize', sizeHandler)
    }
  }, [])

  return value
}

export default useWindowSize
